/**
 * Quão velho está o dado publicado — funções puras.
 *
 * Dois relógios, porque as duas falhas são diferentes:
 * - **o espelho** (`gerado`) roda a cada 5 min; parado há mais de 30 min, a
 *   máquina do agendador tem problema;
 * - **a observação mais nova** (`maisNova`): o METAR sai de hora em hora e o
 *   INMET publica a hora HH por volta de HH+60 min, então 2 h é o normal da
 *   rede; 3 h já é a fonte atrasada.
 */

export const ESPELHO_AVISO_MIN = 30;
export const OBS_AVISO_MIN = 3 * 60;
/** Meio dia sem observação nova: o que está no mapa não é o tempo de agora. */
export const OBS_GRAVE_MIN = 12 * 60;

export type Frescor = 'ok' | 'atrasado' | 'velho' | 'desconhecido';

function minutos(ms: number | null, agora: number): number | null {
  if (ms === null || !Number.isFinite(ms)) return null;
  // Relógio do visitante adiantado não deve virar "atraso negativo".
  return Math.max(0, (agora - ms) / 60_000);
}

export function frescorDe(gerado: number | null, maisNova: number | null, agora: number = Date.now()): Frescor {
  const obs = minutos(maisNova, agora);
  const esp = minutos(gerado, agora);
  if (obs === null && esp === null) return 'desconhecido';
  if (obs !== null && obs >= OBS_GRAVE_MIN) return 'velho';
  if ((obs !== null && obs >= OBS_AVISO_MIN) || (esp !== null && esp >= ESPELHO_AVISO_MIN)) return 'atrasado';
  return 'ok';
}

function quanto(min: number): string {
  return min >= 120 ? `${Math.floor(min / 60)} h` : `${Math.round(min)} min`;
}

export function avisoDeFrescor(gerado: number | null, maisNova: number | null, agora: number = Date.now()): string | null {
  const f = frescorDe(gerado, maisNova, agora);
  if (f === 'ok' || f === 'desconhecido') return null;
  const obs = minutos(maisNova, agora);
  if (f === 'velho') return `A observação mais nova é de ${quanto(obs!)} atrás. O que está no mapa não é o tempo de agora.`;
  if (obs !== null && obs >= OBS_AVISO_MIN) return `Sem observação nova há ${quanto(obs)} — o normal é até 2 h.`;
  return `O espelho das estações não atualiza há ${quanto(minutos(gerado, agora)!)} — o normal é a cada 5 min.`;
}
